import styled from 'styled-components';
import * as symbols from '../assets/symbols/symbols/Symbols.css';
import * as newEventIcons from '../assets/symbols/symbols/newEventIcons';
import * as categoriesIcons from '../assets/symbols/symbols/categoriesIcons';
import * as languagesIcons from '../assets/symbols/symbols/languagesIcons';
import {BGImageCenter} from '../globalVariables/GlobalVariables';
import {Tickets} from '../assets/icons/Tickets';
import {CheckMarkCircle} from '../assets/icons/CheckMarkCircle';
import {EmailCheck} from '../assets/icons/EmailCheck';
import {SmsMessage} from '../assets/icons/SmsMessage';
import Accessibility from '../assets/icons/Accessibility';
import Arrow from '../assets/icons/Arrow';
import Area from '../assets/icons/Area';
import camera from '../assets/icons/camera';
import checkMark from '../assets/icons/checkMark';
import Chevron from '../assets/icons/Chevron';
import clicks from '../assets/icons/clicks';
import DefaultSvg from '../assets/icons/DefaultSvg';
import DoubleSidedArrow from '../assets/icons/DoubleSidedArrow';
import ex from '../assets/icons/ex';
import exCircle from '../assets/icons/exCircle';
import headphones from '../assets/icons/headphones';
import Location from '../assets/icons/Location ';
import MarketingMessage from '../assets/icons/MarketingMessage';
import noResults from '../assets/icons/noResults';
import QRCode from '../assets/icons/QRCode';
import search from '../assets/icons/search';
import searchWithStarts from '../assets/icons/searchWithStarts';
import successCheckMark from '../assets/icons/successCheckMark';
import Time from '../assets/icons/Time';
import Title from '../assets/icons/Title';
import vi from '../assets/icons/vi';

const css={
    container:styled.div` 
        position: fixed;
        top: 0;
        padding: 20px;
        overflow-y: auto;
        height: 100vh;
    `,
    group:styled.div` 
        margin-bottom: 30px;
        display: flex;
        flex-wrap: wrap;
    `,
    symbolDiv:styled.div`
        height: 40px;
        width: 40px;
        background-color: #f2e8cf;
        ${p=>BGImageCenter(p.image,'20px')}
        margin: 2px;
        `,
    iconDiv:styled.div`
        height: 40px;
        width: 40px;
        background-color: #e8f2f0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 2px;
        border: 1px solid #ddd;
        cursor: pointer;
        & > svg {
            max-width: 32px;
            max-height: 32px;
        }
        `,
    title:styled.div`
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
    `,
};

function ViewSymbols() {
    const icons = {
        Tickets,
        CheckMarkCircle,
        EmailCheck,
        SmsMessage,
        Accessibility,
        Arrow,
        Area,
        camera,
        checkMark,
        Chevron,
        clicks,
        DefaultSvg,
        DoubleSidedArrow,
        ex,
        exCircle,
        headphones,
        Location,
        MarketingMessage,
        noResults,
        QRCode,
        search,
        searchWithStarts,
        successCheckMark,
        Time,
        Title,
        vi,
    };

    return (
        <>
            <css.container>
                <css.title>Symbols:</css.title>
                <css.group>
                    {Object.keys(symbols).map(key=>
                        <css.symbolDiv key={key} image={symbols[key]}  onClick={()=>alert(key)}/>
                    )}
                </css.group>
                <css.title>newEventIcons:</css.title>
                <css.group>
                    {Object.keys(newEventIcons).map(key=>
                        <css.symbolDiv key={key} image={newEventIcons[key]}  onClick={()=>alert(key)}/>
                    )}
                </css.group>
                <css.title>categoriesIcons:</css.title>
                <css.group>
                    {Object.keys(categoriesIcons).map(key=>
                        <css.symbolDiv key={key} image={categoriesIcons[key]}  onClick={()=>alert(key)}/>
                    )}
                </css.group>
                <css.title>languagesIcons:</css.title>
                <css.group>
                    {Object.keys(languagesIcons).map(key=>
                        <css.symbolDiv key={key} image={languagesIcons[key]}  onClick={()=>alert(key)}/>
                    )}
                </css.group>
                <css.title>React Icons (from assets/icons):</css.title>
                <css.group>
                    {Object.keys(icons).map(key=>{
                        const IconComponent = icons[key];
                        return (
                            <css.iconDiv key={key} onClick={()=>alert(key)} title={key}>
                                <IconComponent width={24} height={24} />
                            </css.iconDiv>
                        );
                    })}
                </css.group>
            </css.container>
        </>
    );
}

export default ViewSymbols;